import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import Images from 'assets/images/imageData';
import "./assesment.css";
import TableSection from 'components/sales/tableSection/tableSection';

const styles = {
    fontFamily: "sans-serif",
    width: "500px",
  
    border: "1px solid #eee",
    background: "#f3f3f3",
    padding: "25px",
    margin: "20px"
  }; 

const AssesmentHistory = ({
    match,
    history,
    getAssessmentHistory,
    testHistory
}) => { 
    const { id } = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [roleId, setRoleId] = useState();

    const headers = [
      'Level',
      'Total Question',
      'Total Attempted',
      'Total Correct',
      'Score',
      'Status'
    ];

    useEffect(() => {
      const tableData = [
          'level',
          'total_questions',
          'total_attempted',
          'total_correct',
          'marks_percentage',
          'isCleared',
      ];
      //console.log(testHistory);
      if (testHistory && testHistory?.data && testHistory?.data.length > 0) {
          const data = testHistory.data.map((element) =>
              Object.assign(
                  {},
                  ...tableData.map((key) => (
                    (key === 'isCleared' && element['isCleared'] === 0) ? 
                    {[key]: 'Not Cleared'} : (key === 'isCleared' && element['isCleared'] === 1) ? 
                    {[key]: 'Cleared'} : (key === 'marks_percentage') ? {[key]: element[key] + '%'}
                    :{ [key]: element[key] })
                  )
              )
          );  
          data && setListData(data);
          setPageCount(Math.ceil(testHistory.total / testHistory.per_page));
      }
    }, [testHistory]);

    console.log('PAGE::ASSESMENT HISTORY'); 
    
    useEffect(() => {
      setTimeout(() => {
        setIsLoading(true);
        (async () => {
          if(localStorage.getItem('roles')){
            const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
            setRoleId(roles);
          }
         
        })();
        setIsLoading(false);
      }, 1000);
    }, []);

    useEffect(() => {
       if(getAssessmentHistory !== undefined && roleId && match.params.id) {
        (async () => {
          setIsLoading(true);
          const res = await getAssessmentHistory(roleId,match.params.id);
          if(res) {
            console.log(res);
          }
          setIsLoading(false);
        })();  
       }
    },[getAssessmentHistory,roleId,match.params.id]);

    return(
        <Layout
          title={localization.history}
          isGoback={true}
          isLoading={isLoading}
          linkUrl={`${baseUrl}/training-levels`}
        >
        <div className="container-fluid">
         <div className="card">
          <div className='card-header'>Assesment History</div>
          <div className="card-body">
          <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              srNo={testHistory?.data?.from}
          />
          </div>
         </div>
        </div> 
        </Layout>
    );

};
export default AssesmentHistory;